










































import { editFactory } from '@/main/pages';
import { TabulkovaPozice } from '@/modules/ciselnik/dilenske/tabulkovaPozice';
import PracovniPozice from '@/modules/servis/zakazka/pracovniPozice/Card.vue';
import NahradniDily from '@/modules/servis/zakazka/nahradniDily/Card.vue';

import { NAME } from './constants';
import { store } from './store/edit';

export default editFactory(NAME, store).extend({
	components: {
		TabulkovaPoziceSelect: TabulkovaPozice.components.Select,
		PracovniPozice,
		NahradniDily,
	},
});
